import styled from 'styled-components/macro'

export const OrderActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`
